import { useGLTF } from '@react-three/drei';
import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import gsap from 'gsap';
import modelsPos from '/data/modelsPos.json';



export default function Builds() {
    const modelFiles = [
        { path: './models/builds/build1.glb', nodeName: 'build1' },
        { path: './models/builds/build2.glb', nodeName: 'build2' },
        { path: './models/builds/build3.glb', nodeName: 'build3' },
        { path: './models/builds/build4.glb', nodeName: 'build4' },
        { path: './models/builds/build5.glb', nodeName: 'build5' },
        { path: './models/builds/build6.glb', nodeName: 'build6' },
        { path: './models/builds/build7.glb', nodeName: 'build7' },
        { path: './models/builds/build8.glb', nodeName: 'build8' },
        { path: './models/builds/build9.glb', nodeName: 'build9' },
    ];

    const models = modelFiles.reduce((acc, { path, nodeName }) => {
        acc[nodeName] = useGLTF(path);
        return acc;
    }, {});

    const location = useLocation();
    const groupHome = useRef([]);
    const groupContext = useRef([]);

    const homeBuilds = modelsPos.builds.filter(build => build.route === '/');
    const contextBuilds = modelsPos.builds.filter(build => build.route === '/context');

    useEffect(() => {
        if (location.pathname === '/') {
            groupHome.current.forEach((group, index) => {
                if (group) {
                    gsap.to(group.position, {
                        y: 0,
                        duration: 3.5,
                        delay: 1 + index * 0.2,
                        ease: 'power2.out',
                    });
                }
            });
            groupContext.current.forEach((group, index) => {
                if (group) {
                    gsap.to(group.position, {
                        y: -10,
                        duration: 3.5,
                        delay: index * 0.2,
                        ease: 'power2.inOut',
                    });
                }
            });
        }
        else if (location.pathname === '/context') {
            groupHome.current.forEach((group, index) => {
                if (group) {
                    gsap.to(group.position, {
                        y: 0,
                        duration: 3.5,
                        delay: 1 + index * 0.2,
                        ease: 'power2.out',
                    });
                }
            });
            groupContext.current.forEach((group, index) => {
                if (group) {
                    gsap.to(group.position, {
                        y: 0,
                        duration: 3.5,
                        delay: 1 + index * 0.2,
                        ease: 'power2.out',
                    });
                }
            });
        } 
        else {
            groupHome.current.forEach((group, index) => {
                if (group) {
                    gsap.to(group.position, {
                        y: 0,
                        duration: 3.5,
                        delay: 2 + index * 0.2,
                        ease: 'power2.out',
                    });
                }
            });
            groupContext.current.forEach((group, index) => {
                if (group) {
                    gsap.to(group.position, {
                        y: 0,
                        duration: 3.5,
                        delay: 2 + index * 0.2,
                        ease: 'power2.out',
                    });
                }
            });
        } 
    }, [location.pathname]);

    return (
        <>
            {homeBuilds
                .sort((a, b) => a.index - b.index) 
                .map((build, index) => (
                    <group
                        key={index}
                        ref={(el) => (groupHome.current[index] = el)}
                        position={[build.x, build.y - 10, build.z]}
                        rotation={[build.rx * (Math.PI / 180), build.ry * (Math.PI / 180), build.rz * (Math.PI / 180)]} 
                    >
                        <mesh
                            geometry={models[build.model]?.nodes[build.model]?.geometry}
                            receiveShadow
                            onClick={(event) => event.stopPropagation()}
                            onPointerEnter={(event) => event.stopPropagation()}
                        >
                            <meshStandardMaterial color={0x392821} />
                        </mesh>
                    </group>
                ))
            }
            {contextBuilds
                .sort((a, b) => a.index - b.index) 
                .map((build, index) => (
                    <group
                        key={index}
                        ref={(el) => (groupContext.current[index] = el)}
                        position={[build.x, build.y - 10, build.z]}
                        rotation={[build.rx * (Math.PI / 180), build.ry * (Math.PI / 180), build.rz * (Math.PI / 180)]} 
                    >
                        <mesh
                            geometry={models[build.model]?.nodes[build.model]?.geometry}
                            receiveShadow
                            onClick={(event) => event.stopPropagation()}
                            onPointerEnter={(event) => event.stopPropagation()}
                        >
                            <meshStandardMaterial color={0x392821} />
                        </mesh>
                    </group>
                ))
            }
        </>
    );
}